import styled from 'styled-components';
import { spacing, Box } from '@landr/maestro';

export const AsteriskWrapper = styled.div`
    margin-right: ${spacing('xs')};
    line-height: 0;
`;

export const TitleSkeletonWrapper = styled(Box)`
    min-width: 250px;
    width: 40%;
    height: ${spacing('jb')};

    ${({ theme }): string => theme.breakpoint('md')`
        height: ${spacing('xxl')};
    `}
`;
